export const NetworkContextName = "NETWORK";
export const APP_NAME = process.env.REACT_APP_NAME || "Club Rare";
export const IS_DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';
export const DEMO_ETH_PRICE_USD = 3200;

export const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "https://back.clubrare.agencywolfe.com/api/v1"